



































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
// import { State, Action, Getter } from 'vuex-class';
import VueApexCharts from "vue-apexcharts";
import lineChart from "@/data/line-chart";

@Component({
  components: {
    VueApexCharts
  }
})
export default class TimeChart extends Vue {
  @Prop({ default: "Time Admitted" }) title!: string;
  chart: any = lineChart;
  dateSelected: any = "Today";
  items: any = ["Today", "1 Day ago", "2 Days ago"];
}
